import { h } from 'preact'
import UserAvatar from '../User/UserAvatar'
import { User } from '../user-selector/User'

const UserListItem = ({ user, onClick } : { user: User, onClick: (user: User) => void }) =>
  <div class='list-item' onClick={() => onClick(user)}>
    <UserAvatar disableLink disablePopup user={user} />
    <div>{user.name}</div>
  </div>

const UserList = ({ users, onClick }: { users: User[], onClick: (user: User) => void }) =>
  <div class='list'>
    { users.map((user: User) => <UserListItem user={user} onClick={onClick} />) }
  </div>

export default UserList
